import { isExecutionRevertError } from './error-classification.utils'

export const GAS_ESTIMATE_ERRORS = ['timeout', 'reverted', 'rpc_error'] as const
export type GasEstimateError = (typeof GAS_ESTIMATE_ERRORS)[number]

/** Gas estimation sits between the user's Confirm and the wallet prompt, on the submit critical
 * path. A degraded RPC must not hold the flow for the transport's full timeout×retry budget, so
 * the estimate is bounded by this deadline via the shared {@link withTimeout}; on timeout we fall
 * back to wallet-managed gas. `withTimeout` does not cancel the underlying estimate but attaches a
 * handler to its late settlement, so a slow RPC resolving after the deadline can't surface as an
 * unhandled rejection. */
export const GAS_ESTIMATE_TIMEOUT_MS = 3_000

/** Maps an estimateGas failure to the `gas_estimate_error` field on tx_outcome. `withTimeout`
 * rejects with a `TimeoutError` DOMException (AbortSignal.timeout reason); a node-side revert
 * is detected over the whole viem cause chain so transport failures stay `rpc_error`. */
export function classifyGasEstimateError(error: unknown): GasEstimateError {
  if (error instanceof DOMException && error.name === 'TimeoutError') return 'timeout'
  if (isExecutionRevertError(error)) return 'reverted'
  return 'rpc_error'
}
